import { EnterpriseOption } from '@app/core/interfaces/enterprise-option';

/**
 * Check if pcr is available for a queue based on the enterprise option CallRecPermanentFeatures and
 * the service user of the queue.
 *
 * @param option CallRecPermanentFeature option
 */
export function pcrIsAvailable(option: EnterpriseOption | undefined): boolean {
  return option != null && option.available > 0;
}
